import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  margin-bottom: ${layout.measurements.spacing100};
`;
